import * as z from "zod"
import { RequestDraftStatus, RequestDraftRoute } from "@prisma/client"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const RequestDraftModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  status: z.nativeEnum(RequestDraftStatus),
  source: z.string(),
  route: z.nativeEnum(RequestDraftRoute),
  is_actionable: z.boolean(),
  message_id: z.string(),
  email_subject: z.string(),
  email_from: z.string(),
  email_date: z.date().nullish(),
  email_text: z.string(),
  ingest_execution_id: z.number().int().nullish(),
  is_low_confidence: z.boolean(),
  payload: jsonSchema,
  account_id: z.number().int().nullish(),
  request_id: z.number().int().nullish(),
  provider_id: z.string().nullish(),
  quote_id: z.number().int().nullish(),
  discard_reason: z.string().nullish(),
  applied_at: z.date().nullish(),
  applied_summary: jsonSchema,
})
